module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "fm7"
    }
  }, [_c('p', {
    staticClass: "heading2"
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Contents")])])]), _vm._v(" "), _c('p', {
    staticClass: "cont"
  }, [_c('a', {
    attrs: {
      "href": "#/ch_01#ch_01"
    }
  }, [_c('span', [_vm._v("WITCH’S HOUSE")])])]), _vm._v(" "), _c('p', {
    staticClass: "cont"
  }, [_c('span', {
    attrs: {
      "href": "#/ch_02#ch_02",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("THE BAD WEEK AND OLD MISS ASHEMEADE")])])]), _vm._v(" "), _c('p', {
    staticClass: "cont"
  }, [_c('span', {
    attrs: {
      "href": "#/ch_03#ch_03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("RIDE A WHITE HORSE")])])]), _vm._v(" "), _c('p', {
    staticClass: "cont"
  }, [_c('span', {
    attrs: {
      "href": "#/ch_04#ch_04",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("PHINEAS AND PHEBE")])])]), _vm._v(" "), _c('p', {
    staticClass: "cont"
  }, [_c('span', {
    attrs: {
      "href": "#/ch_05#ch_05",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("A COLLAR FOR SABINA")])])]), _vm._v(" "), _c('p', {
    staticClass: "cont"
  }, [_c('span', {
    attrs: {
      "href": "#/ch_06#ch_06",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("OCTAGON HOUSE KEEPS CHRISTMAS")])])]), _vm._v(" "), _c('p', {
    staticClass: "cont"
  }, [_c('span', {
    attrs: {
      "href": "#/ch_07#ch_07",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("CHOLE AND NACKIE")])])]), _vm._v(" "), _c('p', {
    staticClass: "cont"
  }, [_c('span', {
    attrs: {
      "href": "#/ch_08#ch_08",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("STORM CLOUDS")])])]), _vm._v(" "), _c('p', {
    staticClass: "cont"
  }, [_c('span', {
    attrs: {
      "href": "#/ch_09#ch_09",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("CHARLES")])])]), _vm._v(" "), _c('p', {
    staticClass: "cont"
  }, [_c('span', {
    attrs: {
      "href": "#/ch_10#ch_10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("ONE GOLDEN NEEDLE")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31f1d30c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contents.vue
// module id = 72
// module chunks = 0